(() => {
  const createTemplate = () => {
    return `
     <link rel="stylesheet" href="../../../css/reset.css">
     <link rel="stylesheet" href="../../../css/header.css">
     <link rel="stylesheet" href="../../../css/all.css">
     <div class="topup"></div>
    `
  }

  customElements.define('top-up', class extends HTMLElement {
    constructor() {
      super()
      this.attachShadow({ mode: 'open' })
      this.shadowRoot.innerHTML = createTemplate()
      this.addEventListeners()
    }

    addEventListeners() {
      const topup = this.shadowRoot.querySelector(".topup")
      topup.addEventListener("click", () => {
        console.log("topup")
        document.body.scrollIntoView({behavior: 'smooth', block: 'start'});
        document.documentElement.scrollIntoView({behavior: 'smooth', block: 'start'});
      })
    }
  })
})()
